import control from "./control";
export default {
  mixins: [control],
  inject: {
    // markdown组件实例
    $md: {
      default: null
    },
    // ai对话组件实例
    $chat: {
      default: null
    },
    // 智搜组件实例
    $ISList: {
      default: null
    },
  },
  props: {
    /**
     * 卡片是否并行模式输出
     */
    isParallel:{
      type: Boolean,
      default: false
    },
    /**
     * 上下文数据，包含：
     *   {number} index 代码块索引
     *   {string} agentCode 智能体编码
     *   {string} chatId 会话id
     *   {string} msgId 消息id
     *   {Object} ask 提问内容
     *   {Object} answer 回复内容
     *   {Object} options 代码块中参数
     */
    local: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  methods: {
    // 流式监听处理
    $watchStreamOutput(stream) {},
    // 流式监听结束处理
    $endStreamOutput() {},
    // 自定义转图片，用于导出/分享
    // toImage() {},
    // 尺寸变化
    resize() {},
    /**
     * 修改markdown原文中对应的代码块内容，且更新到后端去
     * @param json
     */
    updateMarkdown(json) {
      let {$md, local: {index, agentCode, chatId, msgId, answer}} = this;
      if (!$md || !dsf.iagentUtils) return Promise.reject("缺少环境");
      return $md.updateMarkdown(index, json).then(md => {
        let _answer = _.cloneDeep(answer);
        _answer.msg.md = md;
        return dsf.iagentUtils.replaceAnswerByMessage({
          agentCode,
          chatId,
          msgId,
          answer: md
        });
      })
    }
  }
};
